import { ChartPieModel } from "model/chart/ChartPieModel";
import { getCores } from "utils/chartUtils";
import { VictoryLabel, VictoryPie, VictoryTooltip } from "victory";

type Props = {
    data: ChartPieModel;
}
export default function AuditoriaNaoConformidadeChartPie(props: Props) {

    return (
        <div style={{ width: "50%", height: "65vh" }}>

            <VictoryPie
                colorScale={props?.data?.pieces[0]?.value == 0 ? ["#FF6384"] : ["#36A2EB", "#FF6384"] }
                width={400}
                height={400}
                labelRadius={100}
                data={props.data.pieces.filter(item=>item.value>0).map((item) => ({ x: item.name, y: item.value, label: item.value }))}
                padding={{ top: 10, bottom: 30, left: 50, right: 50 }}
                innerRadius={60}
                labelComponent={
                    <VictoryLabel
                        style={[
                            { fill: '#FFF', fontFamily: "arial", fontSize: 16, fontWeight: 'bold', textAnchor: 'middle' }
                        ]}
                    />
                }
            />
        </div>
    );
}